import css from 'styled-jsx/css';
import { sansSerif, serif } from 'styles/css-constants';
import { sharedPalette, warmGrays } from 'styles/colors/constants';
import { MQ_MEDIUM, MQ_LARGE, MQ_LARGE_ONLY, MQ_MIDLARGE } from 'constants/mq';

export default css`
  .ProductTeaserListItem {
    border-bottom: 1px solid ${warmGrays[2]};
    position: relative;
    text-decoration: none;
  }

  .ProductTeaserListItem:last-child {
    border-bottom: none;
  }

  .ProductTeaserListItem__actions {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  .ProductTeaserListItem__body {
    margin-bottom: 1rem;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
  }

  .ProductTeaserListItem__description,
  .ProductTeaserListItem__name,
  .ProductTeaserListItem__retailer {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .ProductTeaserListItem__cake {
    background-color: ${sharedPalette.watermelon};
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 1rem;
  }

  .ProductTeaserListItem__comparisonPrice {
    margin: 1rem 0 0 0.25rem;
    color: ${warmGrays[6]};
    font-size: var(--fontScaleNeg1);
  }

  .ProductTeaserListItem__counter {
    top: 0;
    left: 0;
    background-color: #fff;
  }

  .ProductTeaserListItem__cta,
  .ProductTeaserListItem__price,
  .ProductTeaserListItem__retailer {
    font-family: ${sansSerif};
  }

  .ProductTeaserListItem__cta {
    border-bottom: 1px solid #000;
    color: #000;
    display: block;
    font-size: var(--baseFontSize);
    font-weight: bold;
    letter-spacing: 0.02em;
    margin: 0 auto;
    text-transform: uppercase;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .ProductTeaserListItem__description {
    font-family: ${serif};
    font-size: var(--fontScale1);
    line-height: 1.5;
    margin-top: 1rem;
  }

  .ProductTeaserListItem__description :global(p) {
    margin-bottom: 1em;
  }

  .ProductTeaserListItem__description :global(a) {
    border-bottom: 1px solid ${sharedPalette.watermelon};
    color: #000;
  }

  .ProductTeaserListItem__image {
    display: block;
    margin-bottom: 1rem;
  }

  .ProductTeaserListItem__meta {
    height: 28px;
    min-width: 64px;
    font-size: 12.5px;
    line-height: 1;
    z-index: 1;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ProductTeaserListItem__name {
    margin-bottom: 0.25rem;
    color: #000;
    font-family: ${serif};
    font-size: var(--fontScale2);
    font-weight: bold;
    line-height: 1.35;
  }

  .ProductTeaserListItem__name a {
    border-bottom: 1px solid ${sharedPalette.watermelon};
    color: #000;
  }

  .ProductTeaserListItem__price {
    margin: 1rem 0;
    color: #000;
    font-size: var(--baseFontSize);
    font-weight: bold;
  }

  .ProductTeaserListItem__retailer,
  .ProductTeaserListItem__retailer :global(a) {
    color: ${warmGrays[6]};
    font-size: var(--fontScaleNeg1);
    text-transform: uppercase;
  }

  @supports (display: grid) {
    @media screen and ${MQ_MEDIUM} {
      .ProductTeaserListItem__body {
        margin-bottom: 1.25rem;
        align-items: baseline;
      }

      .ProductTeaserListItem__cake {
        font-size: 14px;
      }

      .ProductTeaserListItem__counter {
        font-size: 17px;
      }

      .ProductTeaserListItem__wishlistCta {
        margin-left: 0.5rem;
      }

      .ProductTeaserListItem__description {
        grid-area: description;
        max-width: none;
        min-width: 0;
      }

      .ProductTeaserListItem__meta {
        height: 40px;
        min-width: 86px;
      }

      .ProductTeaserListItem__name {
        grid-area: name;
        margin-bottom: 0;
      }

      .ProductTeaserListItem__price {
        grid-area: price;
        margin-bottom: 0;
      }

      .ProductTeaserListItem__retailer {
        grid-area: retailer;
        margin-top: 0.375rem;
      }

      .ProductTeaserListItem :global(.Placeholder) {
        max-height: none;
      }

      /* VARIANTS */
      .ProductTeaserListItem--post .ProductTeaserListItem__counter {
        font-size: 17px;
      }

      .ProductTeaserListItem--post .ProductTeaserListItem__body {
        display: grid;
        grid-template-areas:
          'sponsor     sponsor'
          'name        price'
          'retailer    comparison'
          'description description';
        grid-template-columns: 1fr fit-content(25%);
      }

      .ProductTeaserListItem--post .ProductTeaserListItem__price {
        justify-self: end;
        padding-right: 1.5rem;
      }

      .ProductTeaserListItem--post .ProductTeaserListItem__comparisonPrice {
        grid-area: comparison;
        align-self: start;
        justify-self: end;
        margin: 0;
        padding-right: 1.5rem;
      }

      .ProductTeaserListItem--wishList .ProductTeaserListItem__body {
        margin-bottom: 1rem;
      }
    }

    @media screen and ${MQ_LARGE} {
      .ProductTeaserListItem__comparisonPrice {
        font-size: var(--baseFontSize);
      }

      .ProductTeaserListItem--post .ProductTeaserListItem__cta {
        font-size: calc(var(--baseFontSize) * 1.125);
      }

      .ProductTeaserListItem__price {
        font-size: var(--fontScale1);
      }

      .ProductTeaserListItem :global(.Placeholder) {
        max-height: none;
      }
    }

    @media screen and ${MQ_MIDLARGE} {
      .ProductTeaserListItem :global(.Placeholder) {
        max-height: none;
      }
    }
  }

  /* VARIANTS */
  .ProductTeaserListItem--post {
    margin-bottom: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .ProductTeaserListItem--wishList .ProductTeaserListItem__body {
    margin-bottom: 0;
  }

  .ProductTeaserListItem--wishList .ProductTeaserListItem__counter,
  .ProductTeaserListItem--wishList .ProductTeaserListItem__cake,
  .ProductTeaserListItem--wishList .ProductTeaserListItem__wishlistCta,
  .ProductTeaserListItem--wishList .ProductTeaserListItem__description {
    display: none;
  }

  .ProductTeaserListItem--wishList .ProductTeaserListItem__price {
    font-size: var(--fontScaleNeg1);
  }

  .ProductTeaserListItem--wishList :global(.Figure__image--original) {
    object-fit: cover;
  }

  @media screen and ${MQ_MEDIUM} {
    .ProductTeaserListItem--wishList .ProductTeaserListItem__name {
      font-size: var(--fontScale1);
    }

    .ProductTeaserListItem--wishList .ProductTeaserListItem__price {
      margin-bottom: 1rem;
    }
  }

  @media screen and ${MQ_LARGE_ONLY} {
    .ProductTeaserListItem--wishList .ProductTeaserListItem__cta {
      font-size: calc(var(--baseFontSize) / 1.125);
    }

    .ProductTeaserListItem--wishList .ProductTeaserListItem__name {
      font-size: var(--baseFontSize);
    }
  }

  @media screen and ${MQ_LARGE} {
    .ProductTeaserListItem--wishList .ProductTeaserListItem__price {
      font-size: calc(var(--baseFontSize) / 1.125);
    }
  }
`;
